import webClient from '@/network/clients/webClientSetup'
import mocksClient from '@/network/clients/mocksClientSetup'
import { mobileClient, mobileClientPortal } from '@/network/clients/mobileClientSetup'

export const httpClient = window.cordova ? (process.env.VUE_APP_MOCKS === 'true' ? mocksClient.ib : mobileClient) : (process.env.VUE_APP_MOCKS === 'true' ? mocksClient.ib : webClient.ib)
export const httpClientPortal = window.cordova ? mobileClientPortal : (process.env.VUE_APP_MOCKS === 'true' ? mocksClient.portal : webClient.portal)
export const httpClientUrlStringBuilder = process.env.VUE_APP_MOCKS === 'true' ? mocksClient.urlIB : webClient.urlIB
